module.exports = __webpack_public_path__ + "static/media/us-flag.db0d2266.svg";